import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { translate } from "react-switch-lang";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { default as Swal, default as SweetAlert } from "sweetalert2";
import { ModuleDto } from "../../../../models/moduleDto";
import { TrainingPathDto } from "../../../../models/trainingPathDto";
import { TrainingPathTanslationDto } from "../../../../models/trainingPathTranslationDto";
import hasRoles from "../../../../security/hasRoles";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import Breadcrumbs from "../../../../shared/breadcrumb/breadCrumb";
import { RootState } from "../../../../store";
import ButtonComponent from "../components/buttonComponent";
import PaginationComponent from "../components/pagination";
import ModulesListOverview from "./modulesListOverview";
import styles from "./trainingPathOverview.module.scss";

const TrainingPathOverview: React.FC<{ t: (key: string) => string }> = props => {
  const [expanded1, setexpanded1] = useState(true);
  const [expanded2, setexpanded2] = useState(false);
  const [expanded3, setexpanded3] = useState(false);
  const [expanded4, setexpanded4] = useState(false);
  const [expanded5, setexpanded5] = useState(false);
  const [modules, setModules] = useState<ModuleDto[]>([]);
  const [trainingTranslation, setTrainingTranslation] = useState<TrainingPathTanslationDto>(new TrainingPathTanslationDto());
  const Accordion1 = () => {
    setexpanded1(!expanded1);
    setexpanded2(false);
    setexpanded3(false);
    setexpanded4(false);
    setexpanded5(false);
  };
  const Accordion2 = () => {
    setexpanded2(!expanded2);
    setexpanded1(false);
    setexpanded3(false);
    setexpanded4(false);
    setexpanded5(false);
  };
  const Accordion3 = () => {
    setexpanded3(!expanded3);
    setexpanded2(false);
    setexpanded1(false);
    setexpanded4(false);
    setexpanded5(false);
  };
  const Accordion4 = () => {
    setexpanded4(!expanded4);
    setexpanded5(false);
    setexpanded3(false);
    setexpanded2(false);
    setexpanded1(false);
  };
  const Accordion5 = () => {
    setexpanded5(!expanded5);
    setexpanded4(false);
    setexpanded3(false);
    setexpanded2(false);
    setexpanded1(false);
  };
  const [currentPage, setCurrentPage] = useState(0);
  const [modulesPerPage] = useState(4);
  const [pageNumbers, setPageNumbers] = useState(0);
  const params = useParams<{ id: string }>();
  const history = useHistory();
  const keycloak = useKeycloak().keycloak;
  const httpClient = useHttpClient(keycloak.authenticated);
  const userCanSubscribe = !keycloak.authenticated;
  const userCanStart = hasRoles(["ROLE_ELEARNING_USER"], keycloak) && !hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const [isUsers, setIsUsers] = useState(false);
  const currentLang = useSelector((state: RootState) => state.language.currentLang);

  useEffect(() => {
    async function fetchTrainingPath() {
      const response = await httpClient.current?.get(`/trainingPathTranslation/trainingPath/${params?.id}`);
      let result = (response.data as TrainingPathTanslationDto[]).filter(training => training.language === currentLang.toUpperCase());
      setTrainingTranslation(result[0]);
      getModules(result[0].id);
    }
    fetchTrainingPath();
    // eslint-disable-next-line
  }, []);

  async function getModules(trainingTranslationID: number) {
    const response = await httpClient.current?.get(`/module/trainingPathTranslation/perPage/${trainingTranslationID}`, { params: { page: currentPage, size: modulesPerPage } });
    setModules(response.data?.content as ModuleDto[]);
    setPageNumbers(response?.data?.totalPages);
    const responseData = await httpClient.current?.get(`/trainingPath/byUser`, { params: { language: currentLang.toUpperCase(), archived: false } });
    setIsUsers((responseData.data.content as TrainingPathDto[]).some(trainingPath => Number.parseInt(params.id) === trainingPath.id));
  }

  const paginate = (index, e) => {
    e.preventDefault();
    setCurrentPage(index);
    httpClient.current?.get(`/module/trainingPathTranslation/perPage/${trainingTranslation.id}`, { params: { page: index, size: modulesPerPage } }).then(response => {
      setModules(response?.data?.content as ModuleDto[]);
      setPageNumbers(response?.data?.totalPages);
    });
  };

  const onTrainingPathSubscribe = () => {
    history.push(`/signup?requested-training-path=${trainingTranslation.id}`);
  };

  const addTrainingPathToUser = () => {
    httpClient.current?.post(`/trainingPath/addTrainingPathToUser/${trainingTranslation.id}`).then(() => {
      history.push(`/training-paths`);
    });
  };

  return (
    <>
      <Breadcrumbs parent={props.t("training_path_list")} title={props.t("training_path_details")} />
      <Col sm="12">
        <Accordion defaultActiveKey="0">
          <Card className={styles["user-training-tabs-wrapper"]}>
            <CardBody>
              <div>
                <h3>{trainingTranslation?.title}</h3>
              </div>
              <div className="default-according style-1" id="accordionoc">
                <Card>
                  <CardHeader className="bg-primary colorStyle">
                    <h5 className="mb-0">
                      <Accordion.Toggle className="btn btn-link txt-white " id={styles["blackpolice"]} color="default" onClick={Accordion1} eventKey="0">
                        <i className={expanded1 ? "fa fa-plus" : "fa fa-minus"}></i>
                        Préambule
                      </Accordion.Toggle>
                    </h5>
                  </CardHeader>
                  <Accordion.Collapse eventKey="0">
                    <CardBody>{trainingTranslation?.description}</CardBody>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CardHeader className="bg-primary colorStyle">
                    <h5 className="mb-0">
                      <Accordion.Toggle className="btn btn-link txt-white" id={styles["blackpolice"]} color="primary" onClick={Accordion2} eventKey="1">
                        <i className={expanded2 ? "fa fa-plus" : "fa fa-minus"}></i>
                        Capacité Visée
                      </Accordion.Toggle>
                    </h5>
                  </CardHeader>
                  <Accordion.Collapse eventKey="1">
                    <CardBody>{trainingTranslation?.capacity}</CardBody>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CardHeader className="bg-primary colorStyle">
                    <h5 className="mb-0">
                      <Accordion.Toggle className="btn btn-link txt-white" id={styles["blackpolice"]} color="primary" onClick={Accordion3} eventKey="2">
                        <i className={expanded3 ? "fa fa-plus" : "fa fa-minus"}></i>
                        La Durée Moyenne Du Parcours
                      </Accordion.Toggle>
                    </h5>
                  </CardHeader>
                  <Accordion.Collapse eventKey="2">
                    <CardBody>{`Nombre d'heures : ${trainingTranslation.trainingPathDuration}`}</CardBody>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CardHeader className="bg-primary colorStyle">
                    <h5 className="mb-0">
                      <Accordion.Toggle className="btn btn-link txt-white" id={styles["blackpolice"]} color="primary" onClick={Accordion4} eventKey="3">
                        <i className={expanded4 ? "fa fa-plus" : "fa fa-minus"}></i>
                        Prérequis
                      </Accordion.Toggle>
                    </h5>
                  </CardHeader>
                  <Accordion.Collapse eventKey="3">
                    <CardBody>{trainingTranslation?.preRequest}</CardBody>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CardHeader className="bg-primary colorStyle">
                    <h5 className="mb-0">
                      <Accordion.Toggle className="btn btn-link txt-white" id={styles["blackpolice"]} color="primary" onClick={Accordion5} eventKey="4">
                        <i className={expanded5 ? "fa fa-plus" : "fa fa-minus"}></i>
                        Plan de cycle
                      </Accordion.Toggle>
                    </h5>
                  </CardHeader>
                  <Accordion.Collapse eventKey="4">
                    <CardBody>
                      <ModulesListOverview modules={modules}></ModulesListOverview>
                      <PaginationComponent pageNumbers={pageNumbers} paginate={paginate} currentPage={currentPage}></PaginationComponent>
                    </CardBody>
                  </Accordion.Collapse>
                </Card>
              </div>

              <Row className="justify-content-end padding-top">
                {userCanSubscribe && <ButtonComponent disable={false} buttonType={"button"} save={true} onClick={onTrainingPathSubscribe} buttonText={props.t("training_path_subscribe")} />}

                {userCanStart && isUsers && <ButtonComponent disable={false} buttonType={"button"} save={true} buttonText={props.t("training_path_start")} />}

                {userCanStart && !isUsers && (
                  <ButtonComponent
                    disable={false}
                    buttonType={"button"}
                    save={true}
                    onClick={() => {
                      SweetAlert.fire({
                        title: "Êtes-vous sûr que vous voulez ajouter ce parcours?",
                        cancelButtonText: props.t("cancel"),
                        confirmButtonText: "Ajouter !",
                        confirmButtonColor: "#FF0000",
                        reverseButtons: true,
                        showCancelButton: true,
                        icon: "warning",
                      }).then(result => {
                        if (result.isConfirmed) {
                          addTrainingPathToUser();
                          Swal.fire("Parcours Bien Ajouté!", "", "success");
                        }
                      });
                    }}
                    buttonText={props.t("training_path_subscribe")}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Accordion>
      </Col>
    </>
  );
};

export default translate(TrainingPathOverview);
